const my_profile = {
  viewMyClubSeacretProfile: "私のClubSecretプロフィールを見る", // translated
  viewMoreDetails: "詳細を見る", // translated
  verifiedEmail: "確認済みメールアドレス", // translated
  unverifiedEmail: "未確認のメール", // translated
  pointsOut: "指摘している", // translated
  pointsIn: "ポイントイン", // translated
  balance: "バランス", // translated
  pointsHistoryTable: "ポイント履歴テーブル", // translated
  topUp: "補充する", // translated
  createdFrom: "作成日（開始）", // translated
  createdTo: "作成日（終了）", // translated
  selectStatus: "ステータスを選択...", // translated
  searchByTitle: "タイトルで検索...", // translated
  offerStatus: "オファーステータス", // translated
  selectOfferStatus: "すべて", // translated
  quotationSent: "見積もり送信済み", // translated
  offerInProgress: "オファー進行中", // translated
  offerAvailable: "オファー利用可能", // translated
  offerAccepted: "オファー承認済み", // translated
};

export default my_profile;
